import {
    EKanbanCardProperty,
    EMPTY_ARRAY,
    IApplicationState,
    TBoardId,
    TKanbanCardProperty
} from '../../../../types/types';
import { getBoardMeta } from './getBoardMeta';

export const getBoardDefaultCardPreviewCustomProperties = (
    state: IApplicationState,
    boardId: TBoardId,
): TKanbanCardProperty[] => {
    const meta = getBoardMeta(state, boardId);
    return meta && meta.defaultCardPreviewCustomProperties || EMPTY_ARRAY;
};
